import { zs } from './zod';

export const tagField = zs.string().trim().min(1).max(50);
